import style from "./MachineLearning.module.scss";

const MachineLearning = () => {
  return (
    <div className={`sw ${style.wrapper}`}>
      <h2>Data Science Projects</h2>

      <div className={style.projects}>
        <div className={style.project}>
          <a
            className={style.project_link}
            href="https://github.com/barnascript/ML_Salary_Prediction"
          >
            <h2 className={style.project_title}>
              Software Developer's Salary Prediction
            </h2>
            <a href="https://barnascript-ml-salary-prediction-app-tug4ul.streamlit.app">
              Link to the app
            </a>
          </a>

          <p>
            A Machine Learning Project in Python that predicts the salry of
            software developer. Data was gotten from Stackoverflow 2020 survey
          </p>
          <a href="https://github.com/barnascript/ML_Salary_Prediction">
            Link to the Github Repository
          </a>
          <div className={style.tools}>
            ● Python ● Machine Learning ● Random Forest Regressor ● Pandas ●
            Streamlit
          </div>
        </div>
        <div className={style.project}>
          <a
            className={style.project_link}
            href="https://github.com/barnascript/Data_Titanic_Dash_Plotly_App/tree/main"
          >
            <h2 className={style.project_title}>
              Titanic Incidence Prediction
            </h2>
          </a>

          <p>
            A Machine Learning Project in Python that predicts information about
            the deaths, lives from the Titanic Dataset.
          </p>
          <a href="https://github.com/barnascript/Data_Titanic_Dash_Plotly_App/tree/main">
            Link to the Github Repository
          </a>
          <div className={style.tools}>
            ● Python ● Machine Learning ● Dash ● Pandas
          </div>
        </div>
        <div className={style.project}>
          <a
            className={style.project_link}
            href="https://github.com/barnascript/Machine_learning_image_segmentation/tree/main"
          >
            <h2 className={style.project_title}>Image Segmentation</h2>
          </a>

          <p>
            This projects splits the color of an image into blue, red, and green
          </p>
          <a href="https://github.com/barnascript/Machine_learning_image_segmentation/tree/main">
            Link to the Github Repository
          </a>
          <div className={style.tools}>
            ● Thresholding ● Clustering ● Edge-based segmentation ● Region-based
            segmentation ● Semantic segmentation
          </div>
        </div>
        <div className={style.project}>
          <a
            className={style.project_link}
            href="https://github.com/barnascript/ML_Wine_Quality_Prediction"
          >
            <h2 className={style.project_title}>Wine Quality Prediction</h2>
          </a>

          <p>
            This projects predict wine quality based on certain inputs like
            chloride, alcohol and many others
          </p>
          <a href="https://github.com/barnascript/ML_Wine_Quality_Prediction">
            Link to the Github Repository
          </a>
          <div className={style.tools}>
            ● Python ● Machine Learning ● tkinter ● Pandas ● Gradient Boosting
            Classifier ● Random Forest Classifier ● Decision Tree Classifier ● K
            Neighbours Classifier Model ● Support Vector Machine
          </div>
        </div>
        <div className={style.project}>
          <a
            className={style.project_link}
            href="https://github.com/barnascript/ML_Sales_Forecasting"
          >
            <h2 className={style.project_title}>Sales Forecasting</h2>
          </a>

          <p>This projects predict Sales</p>
          <a href="https://github.com/barnascript/ML_Sales_Forecasting">
            Link to the Github Repository
          </a>
          <div className={style.tools}>
            ● Python ● Machine Learning ● Pandas ● Jupyter Notebook
          </div>
        </div>
        <div className={style.project}>
          <a
            className={style.project_link}
            href="https://github.com/barnascript/Machine_learning_Image_transformation/blob/main/Image%20Transformation.ipynb"
          >
            <h2 className={style.project_title}>Image Transformation</h2>
          </a>
          <p>
            This projects apply different geometric transformations to images,
            like translation, rotation, affine transformation.
          </p>
          <a href="https://github.com/barnascript/Machine_learning_Image_transformation/blob/main/Image%20Transformation.ipynb">
            Link to the Github Repository
          </a>
          <div className={style.tools}>
            ● Transformations ● Scaling ● Translation ● Rotation
          </div>
        </div>
        <div className={style.project}>
          <a
            className={style.project_link}
            href="https://github.com/barnascript/rock-vs-mine"
          >
            <h2 className={style.project_title}>Rock vs Mine Prediction</h2>
          </a>

          <p>
            A Machine Learning Project in Python that predicts an object to
            either be a rock or a mine using Logistic Regression.
          </p>
          <a href="https://github.com/barnascript/rock-vs-mine">
            Link to the Github Repository
          </a>
          <div className={style.tools}>
            ● Python ● Machine Learning ● Logistic Regression ● Pandas
          </div>
        </div>
        <div className={style.project}>
          <a
            className={style.project_link}
            href="https://dna-nucleotide-count-app.onrender.com"
          >
            <h2 className={style.project_title}>
              DNA Nucleotide Count Web-App
            </h2>
          </a>

          <div>
            This project uses Python and Streamlit to count DNA Nucleotides.
            <br /> <br />
            Users can <br /> <br />
            <ol>
              <li>
                1. Paste in their DNA sequence,
                <li>
                  2. Get the number of adenines,thymines, guanines and cytosines
                  and
                </li>
                <li>3. See the visualization in form of a graph.</li>
              </li>
            </ol>
          </div>
          <a href="https://github.com/barnascript/DNA-Nucleotide-Count-Web-App">
            Link to the Github Repository
          </a>
          <div className={style.tools}>● Python ● Streamlit ● Render</div>
        </div>
        <div className={style.project}>
          <a
            className={style.project_link}
            href="https://stocks-prediction-1gko.onrender.com"
          >
            <h2 className={style.project_title}>Stock Price App</h2>
          </a>

          <p>
            This projects shows the closings and the volumes of stock prices of
            companies like Google in time series.
          </p>
          <a href="https://github.com/barnascript/Simple-Stock-Prediction-App">
            Link to the Github Repository
          </a>
          <div className={style.tools}>
            ● Python ● Streamlit ● YFinance ● Render
          </div>
          <a href="https://github.com/barnascript/hr">Github Repo</a>
        </div>
        <div className={style.project}>
          <a
            className={style.project_link}
            href="https://github.com/barnascript/Spectral-Co-Clustering-algorithm"
          >
            <h2 className={style.project_title}>
              Spectral Co-clustering algorithm
            </h2>
          </a>

          <p>
            I demonstrated Spectral Co-Clustering's effectiveness in identifying
            dataset patterns through bicluster generation and rearrangement,
            validating its robust pattern recognition.
          </p>
          <a href="https://github.com/barnascript/Spectral-Co-Clustering-algorithm">
            Link to the Github Repository
          </a>
          <div className={style.tools}>
            ● Machine Learning ● Spectral Co-clustering
          </div>
        </div>
        <div className={style.project}>
          <a
            className={style.project_link}
            href="https://github.com/barnascript/Spectral-Co-Clustering-algorithm"
          >
            <h2 className={style.project_title}>
              Spectral Biclustering algorithm
            </h2>
          </a>

          <p>
            I built a project focusing on a checkerboard pattern. Utilizing the
            SpectralBiclustering algorithm, it intelligently organized squares
            by identifying similar patterns among rows and columns, enhancing
            data analysis clarity.
          </p>
          <a href="https://github.com/barnascript/Spectral-Co-Clustering-algorithm">
            Link to the Github Repository
          </a>
          <div className={style.tools}>
            ● Machine Learning ● Spectral Biclustering
          </div>
        </div>
      </div>
    </div>
  );
};

export default MachineLearning;
